import React from "react";

export const ADMIN_TABS = [
  { key: "site-control", label: "Site Control" },
  { key: "orders", label: "Orders" },
  { key: "team-orders", label: "Team Orders" },
  { key: "newsletter", label: "Newsletter" },
  { key: "messages", label: "Messages" },
  { key: "reviews", label: "Reviews" },
  { key: "images", label: "Product Images" },
];

const AdminTabs = ({ tab, setTab }) => (
  <div className="flex gap-1 border-b border-line overflow-x-auto hide-scrollbar mb-8">
    {ADMIN_TABS.map((t) => (
      <button
        key={t.key}
        type="button"
        onClick={() => setTab(t.key)}
        className={`px-5 py-3 text-[11px] tracking-[0.18em] uppercase font-bold whitespace-nowrap border-b-2 -mb-px ${
          tab === t.key ? "border-ink text-ink" : "border-transparent text-mute hover:text-ink"
        }`}
        data-testid={`admin-tab-${t.key}`}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default AdminTabs;
